import { Identifier as s } from "@js-dot/core";
var e = /^#[A-Z][A-Z_]*$/,
  n = class extends s {
    constructor(t) {
      super(f(t));
    }
  };
function f(r) {
  if (!e.test(r)) throw new SyntaxError("\uAE30\uB2A5 \uC2DD\uBCC4 \uAC12\uC740 #SNAKE_CASE \uD615\uD0DC\uB85C \uAE30\uC220\uD574\uC57C \uD569\uB2C8\uB2E4.");
  return r;
}
import { Identifier as i } from "@js-dot/core";
var A = /^#[A-Z][A-Z0-9_]*$/,
  o = class extends i {
    constructor(t) {
      super(E(t));
    }
  };
function E(r) {
  if (!A.test(r)) throw new SyntaxError(`\uBAA8\uB4C8 \uC2DD\uBCC4\uAC12(${r})\uC758 \uD615\uD0DC\uAC00 \uC77C\uCE58\uD558\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4, #SNAKE_CASE \uD615\uD0DC\uB85C \uAE30\uC220\uD574\uC57C \uD569\uB2C8\uB2E4.`);
  return r;
}
export { n as NamedFeature, o as NamedModule };